import { client } from "api";
import { OrderIncompleteReason } from "models/OrderIncompleteReason";

export type CreateReasonRequest = Pick<OrderIncompleteReason, "description">;

export type CreateReasonResponse = OrderIncompleteReason[];

export const createReason = (data: CreateReasonRequest) =>
  client.post<CreateReasonResponse>(`/order-incomplete-reasons`, data).then((res) => res.data);
